export const Mutation = {
    // Production Lines
    INITIALIZE_PRODUCTION_LINES: 'INITIALIZE_PRODUCTION_LINES',
    CREATE_PRODUCTION_LINE  : 'CREATE_PRODUCTION_LINE',
    UPDATE_PRODUCTION_LINE  : 'UPDATE_PRODUCTION_LINE',
    DELETE_PRODUCTION_LINE  : 'DELETE_PRODUCTION_LINE',

    // Station
    // INITIALIZE_STATION      : 'INITIALIZE_STATION', //Inicializado junto a Production Lines
    CREATE_STATION          : 'CREATE_STATION',
    UPDATE_STATION          : 'UPDATE_STATION',
    DELETE_STATION          : 'DELETE_STATION',

    // Machines
    // INITIALIZE_MACHINE      : 'INITIALIZE_MACHINE', //Inicializado junto a Machines
    CREATE_MACHINE          : 'CREATE_MACHINE',
    UPDATE_MACHINE          : 'UPDATE_MACHINE',
    DELETE_MACHINE          : 'DELETE_MACHINE',

    // Machine Operation Pivots
    CREATE_MACHINE_OPERATION_PIVOT: 'CREATE_MACHINE_OPERATION_PIVOT',
    UPDATE_MACHINE_OPERATION_PIVOT: 'UPDATE_MACHINE_OPERATION_PIVOT',
    DELETE_MACHINE_OPERATION_PIVOT: 'DELETE_MACHINE_OPERATION_PIVOT',

    // Operation Groups
    INITIALIZE_OPERATION_GROUPS  : 'INITIALIZE_OPERATION_GROUPS',
    CREATE_OPERATION_GROUP  : 'CREATE_OPERATION_GROUP',
    UPDATE_OPERATION_GROUP  : 'UPDATE_OPERATION_GROUP',
    DELETE_OPERATION_GROUP  : 'DELETE_OPERATION_GROUP',

    // Operation
    // INITIALIZE_OPERATION    : 'INITIALIZE_OPERATION', //Inicializado junto a Operation Groups
    CREATE_OPERATION        : 'CREATE_OPERATION',
    UPDATE_OPERATION        : 'UPDATE_OPERATION',
    DELETE_OPERATION        : 'DELETE_OPERATION',

    // Reference Groups
    INITIALIZE_REFERENCE_GROUPS     : 'INITIALIZE_REFERENCE_GROUPS',
    CREATE_REFERENCE_GROUP  : 'CREATE_REFERENCE_GROUP',
    UPDATE_REFERENCE_GROUP  : 'UPDATE_REFERENCE_GROUP',
    DELETE_REFERENCE_GROUP  : 'DELETE_REFERENCE_GROUP',

    // References
    INITIALIZE_REFERENCES   : 'INITIALIZE_REFERENCES',
    CREATE_REFERENCE        : 'CREATE_REFERENCE',
    UPDATE_REFERENCE        : 'UPDATE_REFERENCE',
    DELETE_REFERENCE        : 'DELETE_REFERENCE',

    // Magnitude Units
    INITIALIZE_MAGNITUDE_UNIT  : 'INITIALIZE_MAGNITUDE_UNIT',
    CREATE_MAGNITUDE_UNIT      : 'CREATE_MAGNITUDE_UNIT',
    DELETE_MAGNITUDE_UNIT      : 'DELETE_MAGNITUDE_UNIT',

    // Packagings
    INITIALIZE_PACKAGING   : 'INITIALIZE_PACKAGING',
    CREATE_PACKAGING       : 'CREATE_PACKAGING',
    UPDATE_PACKAGING       : 'UPDATE_PACKAGING',
    DELETE_PACKAGING       : 'DELETE_PACKAGING',

    // Packaging Formats
    INITIALIZE_PACKAGING_FORMATS : 'INITIALIZE_PACKAGING_FORMATS',
    CREATE_PACKAGING_FORMAT : 'CREATE_PACKAGING_FORMAT',
    DELETE_PACKAGING_FORMAT : 'DELETE_PACKAGING_FORMAT',

    // Modals
    CREATE_MODAL     : 'CREATE_MODAL',
    DELETE_MODAL     : 'DELETE_MODAL',

    // Config
    CREATE_UMA_API_CONFIG   : 'CREATE_UMA_API_CONFIG',

    // User permissions
    INITIALIZE_USER_PERMISSIONS : 'INITIALIZE_USER_PERMISSIONS',
    UPDATE_IS_USER_SUPERADMIN   : 'UPDATE_IS_USER_SUPERADMIN',
    UPDATE_IS_USER_ADMIN        : 'UPDATE_IS_USER_ADMIN',
    UPDATE_USERNAME             : 'UPDATE_USERNAME',
}
